import { create as createFedopsLogger } from '@wix/fedops-logger';
import React from 'react';
import { createRoot } from 'react-dom/client';

import './styles/global.scss';
import { App } from 'components/App/App';

createFedopsLogger('ai-store-builder').appLoaded();

const domNode = document.getElementById('root')!;
const root = createRoot(domNode);

root.render(<App />);
